import React from 'react'
import Layout from '../components/Layout'
import * as styles from '../styles/manifesto.module.css'


export default function manifesto() {
    return (

    <Layout>
        <div className={styles.topcomponent}>
            <h1 className={styles.MM}>The Movement Manifesto</h1>
            <p className={styles.manifestoDescription} > We are in the process of finalising "The Movement Manifesto", a set of priniciples that we believe in. The Movement Manifesto outlines the values that influence our company as we design the future of motion capture and the new data economy.</p>
            <p><strong>Coming Soon...</strong></p>
        </div>
          {/* <section className={styles.manifesto}>
              <div className={styles.priciple}>
                <div className={styles.description}>
                  <h3>01</h3>
                  <h3>Placeholder Point 1</h3>
                  <p>c consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
                <img src="/victory.gif" alt="victory" className={styles.victory} />
              </div>
              <hr></hr>
              <div className={styles.principle}>
                  <div className={styles.description}>
                    <h3>02</h3>
                    <h3>Placeholder Point 2</h3>
                    <p>c consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                  </div>
                  <img src="/walking.gif" alt="walking" className={styles.walking} />
              </div>
              <hr></hr>
              <div className={styles.principle}>
                <div className={styles.description}> 
                  <h3>03</h3>
                  <h3>Placeholder Point 3</h3>
                  <p>c consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
                <img src="/arrow.gif" alt="arrow" className={styles.arrow} />
              </div>
              <hr></hr>
              <div className={styles.principle}>
              <div className={styles.description}>
                  <h3>04</h3>
                  <h3>Placeholder Point 4</h3>
                  <p>c consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
                <img src="/globe.gif" alt="globe" className={styles.globe} />
              </div>
              <hr></hr> 
          </section>*/}
    </Layout>

    )
}
